"use client";

import Link from "next/link";
import ProgramList from "./programList/Programlist";

const cards_2 = [
  {
    title: "“The Great Debate”",
    subtitle: "Speaking club",
    description:
      "Поговоримо англійською про актуальне й наболіле, про те, що обговорюють в інтелектуальних колах і просто на обідніх перервах, за вечірнім столом і в коментарях соцмереж. Про те, що б говорили українською. І між нами кажучи, викладач — теж людина. З власним колом інтересів, зі своєю інофобульбашкою, яка з нетерпінням очікує луснути від ваших новин.",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold text-lg"> 250 грн</span> за учасника
      </span>
    ),
    time: "проведено",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: дорослі | A2-B1 рівень | Група 6-10 людей | Тривалість: 1,5 год",
    price: "",
  },
  {
    title: "“The wild robot”",
    subtitle: "Кіновечір",
    description:
      "Хто сказав, що мультфільми для дітей? Наш мульт торкається важливих актуальних і доволі дорослих питань, зокрема про ШІ й про застосування технологій. Він про межу між холодним залізом і теплом людського тіла, між командами й відчуттями. Між точними цифрами і мінливими думками, які ми щоденно компілюємо в лексичний код української мови. Спробуймо їх перекласти англійською, і хто зна, може ви зрозумієте тих людей, які вітаються зі своїм ChatGPT.",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold text-lg"> 250 грн</span> за учасника
      </span>
    ),
    time: "проведено",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: дорослі та підлітки | від рівня А2 | Група 8-14 людей | Тривалість: 2-2,5 год",
    price: "",
  },
  {
    title: "“Wish Dragon”",
    subtitle: "Speaking “My dreams” на основі перегляду мультфільму",
    description:
      "Уявіть, як ви у дитинстві прийшли на урок англійської, а вчителька, замість перевіряти таблицю неправильних дієслів, увімкнула “Пригоди Алладіна”. Так ось, для наших діток цей мульт уже застарів, тож NETFLIX зняли новий. А таблиця неправильних дієслів, хоч і не втратить актуальності, та важливіше почати говорити, навіть з помилками. Наші викладачі запрошують юних гостей до перегляду й обговорення.",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold text-lg"> 250 грн</span> за учасника
      </span>
    ),
    time: "проведено",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: діти | Група 6-12 дітей | Тривалість: 2-2,5 год | від рівня А2",
    price: (
      <span className="text-pretty">
        <span className="max-md:hidden">Вартість: </span>
        <span className="font-bold">
          {" "}
          <span className="text-lg sm:text-xl">300</span> грн
        </span>
      </span>
    ),
  },
  {
    title: "Success: Talent or Hard Work? Education or luckiness?",
    subtitle: "Speaking club",
    description:
      "Поговоримо англійською про актуальне й наболіле, про те, що обговорюють в інтелектуальних колах і просто на обідніх перервах, за вечірнім столом і в коментарях соцмереж. Про те, що б говорили українською. І між нами кажучи, викладач — теж людина.",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold text-lg"> 250 грн</span> за учасника
      </span>
    ),
    time: "проведено",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: дорослі | B1-В2 рівень | Група 6-10 людей | Тривалість: 1,5 год",
    price: (
      <span className="text-pretty">
        <span className="max-md:hidden">Вартість: </span>
        <span className="font-bold">
          {" "}
          <span className="text-lg sm:text-xl">300</span> грн
        </span>
      </span>
    ),
  },
  {
    title: "Mafia in English",
    subtitle: "Гра в мафію",
    description:
      "Засне ваша невпевненість, а прокинеться fluent speaker. Такий ефект справляє гарна компанія у правильному місці. Перевіримо детективні скіли і підтягнемо вашу англійську.",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold"> 250 грн</span> за учасника
      </span>
    ),
    time: "проведено",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: дорослі | Група 8-16 людей | Тривалість: 2 год | рівень А2-В1",
    price: (
      <span className="text-pretty">
        <span className="max-md:hidden">Вартість: </span>
        <span className="font-bold">
          {" "}
          <span className="text-lg sm:text-xl">300</span> грн
        </span>
      </span>
    ),
  },
  {
    title: "“Let’s Play Board Games!”",
    subtitle: "Speaking club ",
    description:
      "Як це, настільні ігри онлайн? Перевіримо в AP Education. І повчимося говорити англійською!",
    postScript: (
      <span>
        <span className="font-bold">Спеціальна пропозиція:</span> Приводьте
        друга — отримайте знижку!
        <span className="font-bold"> 250 грн</span> за учасника
      </span>
    ),
    time: "28 лютого | 19:30",
    descriptionTitle: "Online (платформа Zoom)",
    descritptionSubtitle:
      "Для кого: дорослі | A2-B1 рівень | Група 6-10 людей | Тривалість: 1,5 год",
    price: (
      <span className="text-pretty">
        <span className="max-md:hidden">Вартість: </span>
        <span className="font-bold">
          {" "}
          <span className="text-lg sm:text-xl">300</span> грн
        </span>
      </span>
    ),
  },
];

export default function ConferenceProgram() {
  return (
    <>
      <section
        data-meta="ConferenceProgram"
        className="relative lg:px-24 lg:mt-24"
      >
        <div className="relative container max-w-6xl flex-nowrap mx-auto px-4 my-4 sm:my-8 flex flex-col gap-16">
          <div
            className="hidden lg:block"
            style={{
              position: "absolute",
              writingMode: "vertical-rl",
              transformOrigin: "center",
              transform: "rotate(180deg) translateX(50%)",
              // color: "transparent",
              fontSize: "12rem",
              fontWeight: "bold",
              color: "transparent",
              WebkitTextStroke: "2px white",
              opacity: 0.3,
            }}
          >
            КАЛЕНДАР
          </div>
          <div
            className="block lg:hidden text-center font-bold text-4xl sm:text-5xl"
            style={{
              color: "transparent",
              WebkitTextStroke: "2px white",
            }}
          >
            КАЛЕНДАР
          </div>
          <div id="part_2" className="relative">
            <ProgramList cards={cards_2} />
          </div>
        </div>
        <div className="flex flex-col px-4 justify-center items-center -translate-y-14">
          <Link
            href={"https://ap.education/event-form/"}
            className="uppercase text-white rounded-full py-4  px-6 sm:px-14 custom-gradient-green w-fit font-semibold"
          >
            зареєструватися на подію
          </Link>
        </div>
      </section>
    </>
  );
}
